import { Component } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-claim-business-submitted-dialog',
  templateUrl: './claim-business-submitted-dialog.component.html',
  styleUrls: ['./claim-business-submitted-dialog.component.scss']
})
export class ClaimBusinessSubmittedDialogComponent {

  done = $localize`:@@done:Done`

  constructor(
    public dialogRef: MatDialogRef<ClaimBusinessSubmittedDialogComponent>,
  ) {
  }



  closeDialog() {
    this.dialogRef.close()
  }

  protected readonly close = close;
}
